export enum CommonLinks {
  ContactSupport = 'mailto:support@invisibly.com'
}
